import axios from "axios";
import qs from "qs";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const LANG_KEY = '_lang_';

export default class AxiosHttp {
  get(url, config) {
    const contentLanguage = this._getLanguage();

    if (!config) {
      config = {};
    }

    if (!("headers" in config)) {
      config.headers = {};
    }

    config.headers["content-language"] = contentLanguage;

    config.paramsSerializer = params =>
      qs.stringify(params, {arrayFormat: "repeat"});

    return axios
      .get(url, config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  post(url, data, config) {
    const contentLanguage = this._getLanguage();

    if (!config) {
      config = {};
    }

    if (!("headers" in config)) {
      config.headers = {};
    }

    config.headers["content-language"] = contentLanguage;

    config.paramsSerializer = params =>
      qs.stringify(params, {arrayFormat: "repeat"});

    return axios
      .post(url, data, config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  delete(url, data, config) {
    const contentLanguage = this._getLanguage();

    if (!config) {
      config = {};
    }

    if (!("headers" in config)) {
      config.headers = {};
    }

    config.headers["content-language"] = contentLanguage;

    config.paramsSerializer = params =>
      qs.stringify(params, {arrayFormat: "repeat"});

    return axios
      .delete(url, data, config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  request(url, config) {
    const contentLanguage = this._getLanguage();

    if (!config) {
      config = {};
    }

    if (!("headers" in config)) {
      config.headers = {};
    }

    config.headers["content-language"] = contentLanguage;

    config.paramsSerializer = params =>
      qs.stringify(params, {arrayFormat: "repeat", indices: false});

    return axios
      .request(url, config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }


  _getLanguage() {
    return localStorage.getItem(LANG_KEY) || "nl";
  }
}
